import React from "react";
import Modal from "../modal-new";
import { S3_CDN_DOMAIN } from "../../constants";
import submit from "submit-form";
import SvgIcon from "../SvgIcon";

class JWPlayerVideo extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.state = {
      isPlaying: false,
    };
  }
  handlePlayPause = () => {
    const video = this.videoRef.current;
    this.setState((prevState) => {
      if (video) {
        if (prevState.isPlaying) {
          video.pause();
        } else {
          video.play();
        }
      }
      return { isPlaying: !prevState.isPlaying };
    });
  };
  componentDidMount() {
    // if we have to check if this exercise contains a video that possibly need to get reviewed by coach
    if (this.props.exerciseToEdit) {
      let modifiedBody = {};
      let isReviewed = true;

      if (
        this.props.reviewedByTheCoach &&
        this.props.reviewedByTheCoach === true
      ) {
        isReviewed = true;
      } else {
        modifiedBody = {
          setIndex: parseInt(this.props.setIndex),
          videoIndex: parseInt(this.props.videoIndex),
          exerciseId: this.props.exerciseToEdit,
        };
        isReviewed = false;
      }

      //if is already reviewed or not
      if (!isReviewed) {
        submit(`/actions/exercise/edit-set-video`, {
          method: "POST",
          body: modifiedBody,
        });
      }
    }
  }

  render() {
    const videoOriginal = this.props.originalId?.replace(/\.[^/.]+$/, ".mp4");
    const url = `${S3_CDN_DOMAIN}exercise_set_videos/${this.props.athleteId}/${videoOriginal}`;
    return (
      <Modal className="one-video-modal" title={"Video"}>
        <div className="body">
          <a
            href={url}
            target="_blank"
            download="download"
            role="button"
            data-button-type="secondary"
            data-icon
          >
            <SvgIcon src="/img/new-icons/arrow-down.svg" />
            Download
          </a>
          {!this.state.isPlaying && (
            <SvgIcon
              src="/img/new-icons/play-white.svg"
              classNames="play-icon"
              onClickFn={this.handlePlayPause}
              noFilterOnLight={true}
            />
          )}
          <div className="exercise-library-video-iframe">
            <video
              ref={this.videoRef}
              width="100%"
              height="478"
              controls={this.state.isPlaying}
              controlsList="nodownload"
              disablePictureInPicture
              src={url}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default JWPlayerVideo;
